/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as IndexRouteImport } from './routes/index'
import { Route as AppRouteImport } from './routes/app'
import { Route as DocsRouteImport } from './routes/docs'
import { Route as AppAccountRouteImport } from './routes/app/account'
import { Route as AppSubscriptionsRouteImport } from './routes/app/subscriptions'
import { Route as AppDashboardIndexRouteImport } from './routes/app/dashboard/index'
import { Route as AppDashboardWebhooksRouteImport } from './routes/app/dashboard/webhooks'

const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const AppRoute = AppRouteImport.update({
  id: '/app',
  path: '/app',
  getParentRoute: () => rootRouteImport,
} as any)
const DocsRoute = DocsRouteImport.update({
  id: '/docs',
  path: '/docs',
  getParentRoute: () => rootRouteImport,
} as any)
const AppAccountRoute = AppAccountRouteImport.update({
  id: '/account',
  path: '/account',
  getParentRoute: () => AppRoute,
} as any)
const AppSubscriptionsRoute = AppSubscriptionsRouteImport.update({
  id: '/subscriptions',
  path: '/subscriptions',
  getParentRoute: () => AppRoute,
} as any)
const AppDashboardIndexRoute = AppDashboardIndexRouteImport.update({
  id: '/dashboard/',
  path: '/dashboard/',
  getParentRoute: () => AppRoute,
} as any)
const AppDashboardWebhooksRoute = AppDashboardWebhooksRouteImport.update({
  id: '/dashboard/webhooks',
  path: '/dashboard/webhooks',
  getParentRoute: () => AppRoute,
} as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/app': typeof AppRouteWithChildren
  '/docs': typeof DocsRoute
  '/app/account': typeof AppAccountRoute
  '/app/subscriptions': typeof AppSubscriptionsRoute
  '/app/dashboard/webhooks': typeof AppDashboardWebhooksRoute
  '/app/dashboard/': typeof AppDashboardIndexRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/app': typeof AppRouteWithChildren
  '/docs': typeof DocsRoute
  '/app/account': typeof AppAccountRoute
  '/app/subscriptions': typeof AppSubscriptionsRoute
  '/app/dashboard/webhooks': typeof AppDashboardWebhooksRoute
  '/app/dashboard': typeof AppDashboardIndexRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/app': typeof AppRouteWithChildren
  '/docs': typeof DocsRoute
  '/app/account': typeof AppAccountRoute
  '/app/subscriptions': typeof AppSubscriptionsRoute
  '/app/dashboard/webhooks': typeof AppDashboardWebhooksRoute
  '/app/dashboard/': typeof AppDashboardIndexRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/app'
    | '/docs'
    | '/app/account'
    | '/app/subscriptions'
    | '/app/dashboard/webhooks'
    | '/app/dashboard/'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/app'
    | '/docs'
    | '/app/account'
    | '/app/subscriptions'
    | '/app/dashboard/webhooks'
    | '/app/dashboard'
  id:
    | '__root__'
    | '/'
    | '/app'
    | '/docs'
    | '/app/account'
    | '/app/subscriptions'
    | '/app/dashboard/webhooks'
    | '/app/dashboard/'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  AppRoute: typeof AppRouteWithChildren
  DocsRoute: typeof DocsRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/app': {
      id: '/app'
      path: '/app'
      fullPath: '/app'
      preLoaderRoute: typeof AppRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/docs': {
      id: '/docs'
      path: '/docs'
      fullPath: '/docs'
      preLoaderRoute: typeof DocsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/app/account': {
      id: '/app/account'
      path: '/account'
      fullPath: '/app/account'
      preLoaderRoute: typeof AppAccountRouteImport
      parentRoute: typeof AppRoute
    }
    '/app/subscriptions': {
      id: '/app/subscriptions'
      path: '/subscriptions'
      fullPath: '/app/subscriptions'
      preLoaderRoute: typeof AppSubscriptionsRouteImport
      parentRoute: typeof AppRoute
    }
    '/app/dashboard/': {
      id: '/app/dashboard/'
      path: '/dashboard'
      fullPath: '/app/dashboard/'
      preLoaderRoute: typeof AppDashboardIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/app/dashboard/webhooks': {
      id: '/app/dashboard/webhooks'
      path: '/dashboard/webhooks'
      fullPath: '/app/dashboard/webhooks'
      preLoaderRoute: typeof AppDashboardWebhooksRouteImport
      parentRoute: typeof AppRoute
    }
  }
}

interface AppRouteChildren {
  AppAccountRoute: typeof AppAccountRoute
  AppSubscriptionsRoute: typeof AppSubscriptionsRoute
  AppDashboardWebhooksRoute: typeof AppDashboardWebhooksRoute
  AppDashboardIndexRoute: typeof AppDashboardIndexRoute
}

const AppRouteChildren: AppRouteChildren = {
  AppAccountRoute: AppAccountRoute,
  AppSubscriptionsRoute: AppSubscriptionsRoute,
  AppDashboardWebhooksRoute: AppDashboardWebhooksRoute,
  AppDashboardIndexRoute: AppDashboardIndexRoute,
}

const AppRouteWithChildren = AppRoute._addFileChildren(AppRouteChildren)

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  AppRoute: AppRouteWithChildren,
  DocsRoute: DocsRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
